import React from "react";
import { SNavigation, SPage, SText, SView } from "servisofts-component2";
import { check, request, PERMISSIONS, RESULTS, checkNotifications, openSettings } from 'react-native-permissions';
import { Switch } from "react-native";
import { SBackgroundLocation } from "servisofts-background-location";


export default class permisos extends React.Component {

    render() {
        return <SPage title={"permisos"}>
            {/* <SText>permisos</SText> */}
            <SText padding={20} onPress={()=>{
                // SBackgroundLocation.requestAccessBackgroundLocation()
                // return;
                // SBackgroundLocation.isAccessBackgroundLocationGranted().then(e=>{
                //     console.log(e);
                // }).catch(e=>{
                //     console.error(e);
                // })
                SNavigation.navigate("/permiso")
            }}>{"TEST"}</SText>
            <Permiso label={"Location"} PERMISSION={PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION} />
            <Permiso label={"Background Location"} PERMISSION={PERMISSIONS.ANDROID.ACCESS_BACKGROUND_LOCATION} />
            <Permiso label={"Notifications"} PERMISSION={"android.permission.POST_NOTIFICATIONS"} />
            <SText onPress={() => {
                openSettings("application");
            }}>{"Settings"}</SText>
        </SPage>
    }
}

const Permiso = ({ label, PERMISSION }) => {

    const [status, setStatus] = React.useState("");

    const checkPermision = async () => {
        if (PERMISSION == "android.permission.POST_NOTIFICATIONS") {
            const result = await checkNotifications();
            setStatus(result.status);
        } else {
            const result = await check(PERMISSION);
            setStatus(result);
        }
    }

    React.useEffect(() => {
        checkPermision();
    }, [])
    return <SView row center padding={8}>
        <SText>{label} {status}</SText>
        <Switch value={status == "granted"} onChange={e => {
            request(PERMISSION)
        }} />
    </SView>
}